/* A game payload off the socket is the SIDE's view, computed once per side on the server
   (`zvh/games/broadcast`, 2026-10-17) — every socket on a side gets the same copy instead of the
   server redacting the board once per connection. The one thing in it that is addressed per
   player is the round's events (a cancelled order, a starved city, an enemy sighted: each carries
   `visible_to`), so the whole side's events arrive and this keeps the ones addressed to me. The
   REST bootstrap (`GET /game/`) is already mine and passes through unchanged. */

const STATE_KEYS = ["state", "metadata"]

export const withOnlyMyEvents = (game, userId) => {
  if (!game || userId == null) return game
  const key = STATE_KEYS.find((candidate) => Array.isArray(game[candidate]?.events))
  if (!key) return game
  const mine = (id) => String(id) === String(userId)
  const events = game[key].events.filter((event) => !Array.isArray(event.visible_to) || event.visible_to.some(mine))
  if (events.length === game[key].events.length) return game
  return { ...game, [key]: { ...game[key], events } }
}
